import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular';
import { PlatformModeService } from './services/platform-mode.service';

@Injectable({
  providedIn: 'root'
})
export class AppRouteReuseStrategy implements RouteReuseStrategy {
  private readonly ionicStrategy = new IonicRouteStrategy();

  constructor(private readonly platformModeService: PlatformModeService) {}

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (this.platformModeService.isNativeApp()) {
      return this.ionicStrategy.shouldDetach(route);
    }

    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle | null): void {
    if (this.platformModeService.isNativeApp() && detachedTree) {
      this.ionicStrategy.store(route, detachedTree);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (this.platformModeService.isNativeApp()) {
      return this.ionicStrategy.shouldAttach(route);
    }

    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (this.platformModeService.isNativeApp()) {
      return this.ionicStrategy.retrieve(route);
    }

    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (this.platformModeService.isNativeApp()) {
      return this.ionicStrategy.shouldReuseRoute(future, curr);
    }

    return future.routeConfig === curr.routeConfig;
  }
}
